import React, {Fragment,useEffect, useState} from 'react'
import {
    // AudienceIcon,
    // ChartIcon,
    // DataSourceIcon,
    // DemographyIcon,
    // EngagementIcon,
    // MapIcon,
    MusicIcon,
    // PerformanceIcon,
    // PlaylistIcon,
    // ReachIcon,
    ReleaseIcon,
    PIcon,
    ArrowIcon,
    // ArrowDown,
    // ArrowUp,
    // PlayIcon,
    // Twitter,
    // FemaleIcon, MaleIcon 
} from 'components/vectors';
import { HashLink as Link } from 'react-router-hash-link';
import {NavLink} from 'react-router-dom';
// import AudienceReport from 'components/blocks/AudienceReport'
// import ListItem from 'components/blocks/LisItem';
// import ChartCard from  'components/blocks/ChartCard';
import Doughnut from 'components/blocks/Doughnut';
import PandoraListItem from 'components/blocks/PandoraListItem';
import PlayspreadListItem from 'components/blocks/PlayspreadListItem';
// import ArtisteInfoByLocation from 'components/blocks/ArtisteInfoByLocation';
import {getUserToken, getImage} from 'libs/helpers';
// import { DateRange } from 'react-date-range';
import Calendar from 'react-calendar';
import Select from 'react-select';
import * as moment from 'moment'
import Swal from 'sweetalert2'


// import 'react-date-range/dist/styles.css'; // main style file
// import 'react-date-range/dist/theme/default.css'; // theme css file
// const LineChart = require("react-chartjs").Line;
// const PieChart = require('react-chartjs').Pie;

const SearchResult = props =>  {
    const { history } = props
    let filterParams = props.filterParams; // artist, station, substation
    let {artist, station, substation } = filterParams;
    const [release, setRelease] = useState([])
    const [releasePageNumber, setReleasePageNumber] = useState(1);
    const [releasePageTotal, setReleasePageTotal] = useState(1);
    const [substations, setSubstations] = useState([])
    const [isLoadingRelease, setIsLoadingRelease] = useState(false);
    // const [artistInfoByLocation, setArtistInfoByLocation] = useState([])
    // const [artistInfoPageNumber, setArtistInfoPageNumber] = useState(1);
    // const [artistInfoPageTotal, setArtistInfoPageTotal] = useState(1);
    // const [isLoadingInfoByLocation, setIsLoadingInfoByLocation] = useState(false);
    // const [artisteTopInfo, setArtisteTopInfo] = useState([]);
    // const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const [pandoraDates, setPandoraDates] = useState({});
    const [pandoraDay, setPandoraDay] = useState(0);
    // eslint-disable-next-line
    const [allSubStation, setAllSubStation] = useState([]);
    const [subStationId, setSubStationId] = useState(0);

    // const [dateRange, setDateRange] = useState(new Date());
    const [calendar1, setCalendar1] = useState(moment('01-01-2018', 'DD-MM-YYYY').format('YYYY-MM-DD'));
    const [calendar2, setCalendar2] = useState(moment('01-01-2018', 'DD-MM-YYYY').format('YYYY-MM-DD'));

    const [showCalendar1, setShowCalendar1] = useState(false);
    const [showCalendar2, setShowCalendar2] = useState(false);


    const [releaseDaysActive,setReleaseDaysActive] = useState([{isActive: false}, {isActive: false},{isActive: false},{isActive: false}])
    
    const releaseActiveToggle = (_index) => {
        // releaseDaysActive[_index] = true;
        let arr = releaseDaysActive;
        // eslint-disable-next-line array-callback-return
        releaseDaysActive.map( (value, index) => {
            if (_index === index) {
                arr[index].isActive = true
            } else {
                arr[index].isActive = false;
            }
        })

        setReleaseDaysActive([...arr])
    }
    // console.log('[SEARCH]',filterParams)

    useEffect( () => {
        if (Object.keys(filterParams).length === 0){
            // if there are no search params
            /** DONT FORGET TO UNCOMMENT THE LINE BELOW */
            history.push('/user/landing')
        }
    },[filterParams, history])

    useEffect( () => {
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/subsource?source=${station}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            // console.log('[SUBSTATION]',res)
            if(res.code === 200){
                setSubstations(res.data.stations)
            }
            
        })
        .catch( err => {
            // console.log('[SUBSTATION]',err)
            });
    },[station])

    useEffect(() => { // fetches all the substations
        // /user/stations
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/stations`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            console.log(res);
            if(res.code === 200){
                setAllSubStation(res.data.stations)
                // eslint-disable-next-line array-callback-return
                res.data.stations.map( (station, index) => {
                    if(station.value === substation){
                        setSubStationId(station.id);
                    }
                })
            }
        })
        .catch( err => {
            console.log(err)
        });
    },[substation])

    useEffect(() => { // release
        setRelease([])
        setIsLoadingRelease(true) // set loading release to true
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/search?source=${station}&subsource=${substation}&artist_name=${artist}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            // console.log(res)
            setIsLoadingRelease(false) // set loading release to false
            if(res.code === 200){
                setRelease(res.data.results)
                setPandoraDates(res.data.dates)
                setReleasePageTotal(res.data.total_pages)
            }
            
            // console.log(res);
        })
        .catch( err => {
            setIsLoadingRelease(false) // set loading release to false
            // console.log(err)
        });

    }, [station, substation, artist])

    //pagination

    const fetchReleaseByPage = (action) => {
        let page = releasePageNumber;
        switch (action) {
            case 'add':
                ++page;
                setReleasePageNumber(page);
                break;
        
            default:
                --page;
                setReleasePageNumber(page);
                break;
        }
        // console.log('[PAGE NUMBER]',releasePageNumber)
        setRelease([])
        setIsLoadingRelease(true) // set loading release to true
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/search?source=${station}&subsource=${substation}&artist_name=${artist}&limit=10&page=${page}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            // console.log('[PAGINATION]',res)
            setIsLoadingRelease(false) // set loading release to false
            if(res.code === 200){
                setRelease(res.data.results)
                setPandoraDates(res.data.dates)
                setReleasePageTotal(res.data.total_pages)
            }
            
            // console.log(res);
        })
        .catch( err => {
            setIsLoadingRelease(false) // set loading release to false
            // console.log(err)
        });
    }

    
    // useEffect(()=> {
    //     setArtistInfoByLocation([])
    //     setIsLoadingInfoByLocation(true) // set loading to true
    //     fetch(`https://musicandrights.herokuapp.com/api/v1/user/total_source_data?source=${station}&artist_name=${artist}`, {
    //         method: 'GET',
    //         headers: {'Authorization': `Bearer ${getUserToken()}`,
    //                         'Content-Type': 'application/json'}
    //     })
    //     .then( res => res.json())
    //     .then( res => {
    //         console.log('[LOCATION DATA]',res)
    //         setIsLoadingInfoByLocation(false) // set loading to false
    //         if(res.code === 200){
    //             setArtistInfoByLocation(res.data.results)
    //             setArtistInfoPageTotal(res.data.total_pages)
    //         }
            
    //         console.log(res);
    //     })
    //     .catch( err => {
    //         setIsLoadingInfoByLocation(false) // set loading to false
    //         console.log(err)
    //     });
        
        
    // },[station, artist])

    // const fetchArtistInfoByPage = ()  => {
    //     setArtistInfoByLocation([])
    //     setIsLoadingInfoByLocation(true) //set loading for this
    //     fetch(`https://musicandrights.herokuapp.com/api/v1/user/total_source_data?source=${station}&artist_name=${artist}&limit=10&page=${artistInfoPageNumber}`, {
    //         method: 'GET',
    //         headers: {'Authorization': `Bearer ${getUserToken()}`,
    //                         'Content-Type': 'application/json'}
    //     })
    //     .then( res => res.json())
    //     .then( res => {
    //         console.log('[ARTSTE PAGE ]',res)
    //         setIsLoadingInfoByLocation(false)
    //         if(res.code === 200){
    //             setArtistInfoByLocation(res.data.results)
    //             setArtistInfoPageTotal(res.data.total_pages)

    //         }
            
    //         console.log(res);
    //     })
    //     .catch( err => {
    //         setIsLoadingInfoByLocation(false) // set loading to false
    //         console.log(err)
    //     });
    // }

    // useEffect(() => { // artiste info by location ; it works for non-pandora
    //     if (station !== 'pandora'){
    //         setArtisteTopInfo([])
    //         setIsLoadingInfo(true)
    //         fetch(`https://musicandrights.herokuapp.com/api/v1/user/artist_top?source=${station}&artist_name=${artist}`, {
    //             method: 'GET',
    //             headers: {'Authorization': `Bearer ${getUserToken()}`,
    //                             'Content-Type': 'application/json'}
    //         })
    //         .then( res => res.json())
    //         .then( res => {
    //             console.log('[TOP ARTISTE DATA]',res)
    //             setIsLoadingInfo(false)
    //             if(res.code === 200){
    //                 setArtisteTopInfo(res.data.results)
    //             }
                
    //             console.log(res);
    //         })
    //         .catch( err => {
    //             setIsLoadingInfo(false)
    //             console.log(err)
    //         });
    //     }
        
    // },[station, artist]) 
    
    // eslint-disable-next-line no-unused-vars
    const filterByDays = (day) => {
        setIsLoadingRelease(true) 
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/search?source=${station}&subsource=${substation}&artist_name=${artist}&group_day=${day}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            if(res.code === 200){
                setIsLoadingRelease(false) 
                // console.log('[FILTER BY DAYS]', res.data)
                setRelease(res.data.results)
                setPandoraDates(res.data.dates)
                setReleasePageTotal(res.data.total_pages)
            }
            
            // console.log(res);
        })
        .catch( err =>{
            setIsLoadingRelease(false) 
            //  console.log(err)
            });
    }

    const handleChange = (selectedOption) => {
        const {value} = selectedOption;
        filterParams.substation = value; //resets the substation globally
        setReleaseDaysActive([{isActive: false}, {isActive: false},{isActive: false},{isActive: false}]); //resets the active state of the day filters when a substation changes
        setIsLoadingRelease(true) // set loading release to true

        fetch(`https://musicandrights.herokuapp.com/api/v1/user/search?source=${station}&subsource=${value}&artist_name=${artist}`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            // console.log(res)
            setIsLoadingRelease(false) // set loading release to false
            if(res.code === 200){
                setRelease(res.data.results)
            }
            
            // console.log(res);
        })
        .catch( err => {
            setIsLoadingRelease(false) // set loading release to false
            // console.log(err)
        });
    }

    const toggleCalendarVisibility = ( value) => {
        switch (value){
            case 1:
                setShowCalendar1(true)
                setShowCalendar2(false)
                break;
            case 2: 
                setShowCalendar1(false)
                setShowCalendar2(true)
                break;
            default:
                break;
        }
    }

    const handleCalendarChange1 = (value) => {
        // console.log('[ CALENDAR 1 ]', moment(value).format('YYYY-MM-DD'))
        setShowCalendar1(false)
        setShowCalendar2(false)
        setCalendar1(moment(value).format('YYYY-MM-DD'))
    }
    const handleCalendarChange2 = (value) => {
        // console.log('[ CALENDAR 2 ]', moment(value).format('YYYY-MM-DD') )
        setShowCalendar2(false)
        setCalendar2(false)
        setCalendar2(moment(value).format('YYYY-MM-DD'))

        // console.log('FIRST', calendar1);
        // console.log('SECOND', moment(value).format('YYYY-MM-DD'));
        let diff =  moment(moment(value).format('YYYY-MM-DD')).diff(calendar1, 'days');
        if(diff < 7){
            Swal.fire({
                type: 'error',
                title: 'Date Range errors',
                text: 'Days must be greater than 6 days'
            })
        } else {
            fetchReleaseByDateRange(calendar1, moment(value).format('YYYY-MM-DD'))
        }

        
    }

    const fetchReleaseByDateRange = ( calendar1, calendar2) => {
        setRelease([])
        setIsLoadingRelease(true)
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/search?source=${station}&artist_name=${artist}&subsource=${substation}&from=${calendar1}&to=${calendar2}`,{
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res =>  res.json())
        .then( res => {
            // console.log(res)
            setIsLoadingRelease(false) // set loading release to false
            if(res.code === 200){
                setRelease(res.data.results)
                setReleasePageTotal(res.data.total_pages)
            }
        })
        .catch( err => {
            setIsLoadingRelease(false)
            // console.log(err)
        })
    }

    // const data = {
    //     labels: ["Jan", "Feb", "Mar", "Apr", "May"],
    //     datasets: [
    //         {
    //             label: "My Second dataset",
    //             fillColor: "#D8EDFF",
    //             strokeColor: "#2A9DFD",
    //             pointColor: "#3645F9",
    //             pointStrokeColor: "#3645F9",
    //             pointHighlightFill: "#3645F9",
    //             pointHighlightStroke: "#3645F9",
    //             data: [28, 48, 40, 19, 86]
    //         }
    //     ]
    // };
    // const pieData =  [
    //     {
    //         value: 300,
    //         color:"#3645F9",
    //         highlight: "#3645F9",
    //         label: "Red"
    //     },
    //     {
    //         value: 1250,
    //         color: "#2A9DFD",
    //         highlight: "#2A9DFD",
    //         label: "Green"
    //     },
    //     {
    //         value: 100,
    //         color: "#316DFB",
    //         highlight: "#316DFB",
    //         label: "Yellow"
    //     }
    // ]
    // const chartOptions = {
    //     scaleShowGridLines : false,
    //     scaleShowHorizontalLines: false,
    //     scaleShowVerticalLines: false,

    // }
    return (
    <div className="row search">

        <div className="col-md-3">
            <div className="search__side-bar">
                <ul className="menu_list">
                    <li className={`menu_list-item station text--black`}>Station Source: {station && station.charAt(0).toUpperCase() + station.slice(1)}</li>
                    <Link to="/user/search-result#artiste"><li className={`menu_list-item ${window.location.hash  === '' || window.location.hash  === '#artiste' ? 'active': null}`}> <MusicIcon /> {artist}</li></Link>
                    {/* <Link to="/user/search-result#audience"><li className={`menu_list-item ${window.location.hash  === '#audience' ? 'active': null}`}><AudienceIcon />Pandora Audience</li></Link> */}
                    {/* <Link to="/user/search-result#playlist"><li className={`menu_list-item ${window.location.hash  === '#playlist' ? 'active': null}`}><PlaylistIcon/> Playlist & Discovery</li></Link> */}
                    {/* <Link to="/user/search-result#performance"><li className={`menu_list-item ${window.location.hash  === '#performance' ? 'active': null}`}><PerformanceIcon/> Weekly Performance</li></Link> */}
                    {/* { station && station !== 'pandora' ? 
                    (<Link to="/user/search-result#chartAppearance"><li className={`menu_list-item ${window.location.hash  === '#chartAppearance' ? 'active': null}`}><ChartIcon/> Charts Appearances</li></Link>
                    ):  null} */}
                    {/* <Link to="/user/search-result#audienceMap"><li className={`menu_list-item ${window.location.hash  === '#audienceMap' ? 'active': null}`}><MapIcon /> Audience Map</li></Link> */}
                    {/* <Link to="/user/search-result#audienceDemography"><li className={`menu_list-item ${window.location.hash  === '#audienceDemography' ? 'active': null}`}><DemographyIcon />Audience Demographics</li></Link> */}
                    <Link to="/user/search-result#release"><li className={`menu_list-item ${window.location.hash  === '#release' ? 'active': null}`}><ReleaseIcon/> Release</li></Link>
                    {/* <Link to="/user/search-result#reach"><li className={`menu_list-item ${window.location.hash  === '#reach' ? 'active': null}`}><ReachIcon/> Reach</li></Link> */}
                    {/* <Link to="/user/search-result#engagement"><li className={`menu_list-item ${window.location.hash  === '#engagement' ? 'active': null}`}><EngagementIcon/> Engagement</li></Link> */}
                    {/* <Link to="/user/search-result#dataSource"><li className={`menu_list-item ${window.location.hash  === '#dataSource' ? 'active': null}`}> <DataSourceIcon/> Data Sources & Notice</li></Link> */}
                </ul>
            </div>
        </div>
        <div className="col-md-9">
            <div className="artiste-details">
                <img className="artiste-details-bg" src="/images/png/dashboard.png" alt="" />
                <div className="main">
                    <div>
                        <img className="artiste-avatar" src="/images/png/dashboard.png" alt="" />
                    </div>
                    <div>
                        <div>
                            <p className="text--xs text-left mb-2">Musician</p>
                            <h2 className="text--md text-left mt-2">{artist}</h2>
                        </div>
                        <div className="d-flex flex-row mt-3">
                            <div className="pill pill--transparent text--xs mr-2">Print</div>
                            <div className="pill pill--secondary text--xs ml-2">Following</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="artiste-details artiste-content">
                <div className="row">
                    <div className="col-md-2 d-flex flex-column">
                        <p className="text--xs text--grey">Category</p>
                        <p className="text--xs text--black mt-2">Musician</p>
                    </div>
                    <div className="col-md-10 d-flex flex-column">
                        <p className="text--xs text--grey">Label</p>
                        <p className="text--xs text--black mt-2">Def Jam Recordings GOOD Music, ROC-A-Fella Records</p>
                    </div>
                </div>
                <div className="row my-5">
                    <div className="col-md-4 artiste-stats">
                        <div>
                            <PIcon />
                            <p className="artiste-stats__title text--xs text--grey">asheto lifetime streams</p>
                            <h3 className="artiste-stats__value text--md text--black">9.3 Billion</h3>
                        </div>
                    </div>
                    <div className="col-md-4 artiste-stats">
                        <div>
                            <div className="d-flex flex-row justify-content-end">
                                    <ArrowIcon />
                                </div>
                                <Doughnut degrees="100"/>
                            <p className="artiste-stats__title text--xs text--grey">audience engagement</p>
                            <h3 className="artiste-stats__value text--md text--black">occasional</h3>
                        </div>
                    </div>
                    <div className="col-md-4 artiste-stats">
                        <div>
                            <div className="d-flex flex-row justify-content-end">
                                <ArrowIcon />
                            </div>
                            <Doughnut degrees="40" />
                            <p className="artiste-stats__title text--xs text--grey">artiste stage</p>
                            <h3 className="artiste-stats__value text--md text--black">Epic</h3>
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col">
                        <h3 className="artiste-stats__title text--xs text--grey">more about kanye west</h3>
                        <p className="text--xs text--grey my-2">
                        Kanye Omari West (born June 8, 1977) is an American rapper, singer, songwriter, 
                        record producer, entrepreneur, and fashion designer. Over the course of his career, 
                        West has been an instigator of various developments within mainstream hip hop and 
                        popular music at large. His musical career has drawn on varied 
                        influences including... <NavLink to="/" className="auth__link">WIKIPEDIA</NavLink>
                        </p>
                    </div>
                </div>
                <div>
                    
                </div>
            </div>

            {/* <div className="content" id="audience">
                <div className="row mx-0 d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <AudienceIcon  />
                        <h3 className="text--medium text--black ml-3">Asheto Audience for {artist}</h3>
                    </div>
                </div>
                <div className="row my-4">
                        <div className="col-md-6 artiste-audience">
                            <div>
                                <p className="text--xs text--grey text-uppercase">unique listeners</p>
                                <p className="text--md text--black mt-2">6,551,342</p>
                                <div className="d-flex flex-row align-items-center mb-3">
                                    <ArrowUp />
                                    <p className="text--xs text--success my-1 ml-1">2.7% from last month</p>

                                </div>
                                <LineChart data={data} options={chartOptions} width="auto" height="100" />
                            </div>

                        </div>
                        <div className="col-md-6 artiste-audience">
                            <div>
                                <p className="text--xs text--grey text-uppercase">streams</p>
                                <p className="text--md text--black mt-2">6,551,342</p>
                                <div className="d-flex flex-row align-items-center mb-3">
                                    <ArrowDown />
                                    <p className="text--xs text--danger my-1 ml-1">2.7% from last month</p>
                                </div>
                                <LineChart data={data} options={chartOptions} width="auto" height="100" />
                            </div>
                        </div>
                    </div>
            </div> */}
            {/* playlist starts */}
            {/* <div className="content" id="playlist">
                <div className="row mx-0 d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <PlaylistIcon  />
                        <h3 className="text--medium text--black ml-3">Playlist & Discovery for {artist}</h3>
                    </div>
                </div>
                <div className="my-4">
                    <p className="text--xs text--grey text-uppercase">pandora streams by source</p>
                </div>
                <div className="row mx-0 my-4">
                    <div className="col-md-3">
                        <div className="d-flex flex-row justify-content-around">
                            <PieChart data= {pieData} width="auto" />
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="row mx-0">
                            <div className="col">
                                <div>
                                    <PlayIcon />
                                    <h3 className="text--large mt-3 mb-2">13%</h3>
                                    <p className="text--xs text--secondary my-1">3.6M stream</p>
                                    <p className="text--xs-bold text--grey text-uppercase my-1">kanye west radio</p>

                                </div>
                            </div>
                            <div className="col">
                                <PlayIcon />
                                <h3 className="text--large mt-3 mb-2">13%</h3>
                                <p className="text--xs text--secondary my-1">3.6M stream</p>
                                <p className="text--xs-bold text--grey text-uppercase my-1">Interactive plays </p>

                            </div>
                            <div className="col">
                                <PlayIcon />
                                <h3 className="text--large mt-3 mb-2">13%</h3>
                                <p className="text--xs text--secondary my-1">3.6M stream</p>
                                <p className="text--xs-bold text--grey text-uppercase my-1">Other Pandora stations </p>

                            </div>
                        </div>
                    </div>
                       
                </div>
            </div> */}
            {/* playlist ends */}

            {/* performance starts */}

            {/* <div className="content" id="performance">
                <div className="row mx-0 d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <PerformanceIcon  />
                        <h3 className="text--medium text--black ml-3">Weekly Performance for {artist}</h3>
                    </div>
                </div>

                <div className="row mx-0 mt-5">
                    <h4 className="text--xs-bold text--grey text-uppercase text-left">Audience Engagement</h4>
                </div>
                <div className="row mx-0">
                    <p className="text--small__line-22 text-left text--grey my-2">Kanye West's weekly audience engagement performance is compared to artists with similarly 
                        sized audiences in each network. This section is generated on a weekly basis.</p>

                </div>

                {
                    [1,2,3,4].map( (num, index) => (
                        <AudienceReport key={index} />
                    ))
                }
            </div> */}
            {/* performance starts */}

            {/* chartApperance starts */}
            
            {/* {
                station && station !== 'pandora' ? (
                    <div className="content" id="chartAppearance">
                        <div className="row mx-0 d-flex flex-row justify-content-between">
                            <div className="d-flex flex-row align-items-center">
                                <ChartIcon   />
                                <h3 className="text--medium text--black ml-3">Chart Appearances for {artist}</h3>
                            </div>
                        </div>
                        <div className="row mt-5 mb-2">
                            {
                                isLoadingInfo ?
                                (
                                    <div className="d-flex flex-row align-items-center justify-content-center">
                                        <ChartIcon   />
                                        <h1 className="text--small-bold text--secondary  my-4 ml-3"> Chart Appearances data loading</h1>
                                    </div>
                                )
                                : artisteTopInfo && artisteTopInfo.length < 1 ?
                                (<h1 className="text--small-bold text--black text-center my-4  mx-auto">No Data </h1>)
                                : (
                                    <div className="chart-card__container">
                                        {
                                            
                                            artisteTopInfo && artisteTopInfo.map((info, index) => (
                                                <ChartCard key={index} isActive={false} {...info} />
                                            ))
                                            
                                        }
                                    </div>
                                )

                            }
                            
                        </div>
                    </div>
                ) : null
            } */}
            
            {/* chartApperance ends */}
        
            {/* audienceDemography starts */}
            {/* <div className="content" id="audienceDemography">
                <div className="row mx-0 d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <DemographyIcon   />
                        <h3 className="text--medium text--black ml-3">Audience Demographics for {artist}</h3>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-3">
                        <div className="artiste-demograph">
                            <MaleIcon />
                            <p className="text--md text--black my-2">40%</p>
                            <p className="text--small text--grey">Male</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="artiste-demograph female-icon">
                            <FemaleIcon />
                            <p className="text--md text--black my-2">40%</p>
                            <p className="text--small text--grey">Female</p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div>
                            <div className="">
                                <Twitter />
                                <p className="text--small text--dim-grey my-2">Twitter Mentions</p>
                                <div>
                                    <div className="progress progress-demography">
                                        <div className="progress progress-demography__loader"></div>
                                    </div>
                                </div>
                                <div className="d-flex flex-row justify-content-between my-1">
                                    <p className="text--xs text--grey">52% Male</p>
                                    <p className="text--xs text--grey">48% Female</p>
                                </div>
                            </div>
                            <div className="">
                                <Twitter />
                                <p className="text--small text--dim-grey my-2">Twitter Retweets</p>
                                <div>
                                    <div className="progress progress-demography">
                                        <div className="progress progress-demography__loader"></div>
                                    </div>
                                </div>
                                <div className="d-flex flex-row justify-content-between my-1">
                                    <p className="text--xs text--grey">52% Male</p>
                                    <p className="text--xs text--grey">48% Female</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div> */}
            {/* audienceDemography ends */}

            <div className="content" id="release">
                <div className="row mx-0 d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <ReleaseIcon   />
                        <h3 className="text--medium text--black ml-3">Release for {artist}</h3>
                    </div>
                </div>
                <div className="row mt-3">
                    <Fragment>
                    <div className="col-md-5">
                        <Select
                            value=""
                            defaultValue={substation}
                            onChange={handleChange}
                            options={substations ? substations : null}
                        />
                        {/* <div className="nsForm-select">
                        
                            <select onChange={handleChange}>
                                <option>Select your release metric</option>
                                {
                                    substations && substations.map((substation, index) => (
                                        <option key={index} value={substation.value}>{substation.label}</option>
                                    ))
                                }
                            </select> 
                        </div> */}
                    </div>
                    <div className="col-md-5 px-0 release-side__menu ml-auto">
                        <div className="col mx-0">
                            <div className="row mx-0">
                                {
                                    station && station !== 'pandora' ? (
                                        <Fragment>
                                            <div className="col date-filter">
                                                <p className="text--small-bold text--black mr-auto date-filter-control" onClick={() => toggleCalendarVisibility(1)}>{moment(calendar1).format('Do MMM, YY')}</p>
                                                <p className="text--small-bold text--black ml-auto date-filter-control" onClick={() => toggleCalendarVisibility(2)}>{moment(calendar2).format('Do MMM, YY')}</p>
                                                {
                                                    showCalendar1 ?
                                                    (
                                                        <div className="date-filter-calendar">
                                                            <Calendar
                                                                onChange={handleCalendarChange1}
                                                                value={moment('01-01-2018', 'DD-MM-YYYY').toDate()}
                                                                />
                                                        </div>
                                                    )
                                                    : null
                                                }
                                                
                                                {
                                                    showCalendar2 ? 
                                                    (
                                                        <div className="date-filter-calendar">
                                                                <Calendar
                                                                    onChange={handleCalendarChange2}
                                                                    value={moment('01-01-2018','DD-MM-YYYY').toDate()}
                                                                    />
                                                            </div>
                                                    )
                                                    : null
                                                }
                                            </div>
                                            {/* <div className={`col-md-4 box box-xs box--lavender-border ${releaseDaysActive[0].isActive ? 'active' : ''}`} onClick={() =>{ releaseActiveToggle(0); filterByDays(30)}}><p className="text--small text-center">30 days</p></div>
                                            <div className={`col-md-4 box box-xs box--lavender-border ${releaseDaysActive[1].isActive ? 'active' : ''}`} onClick={() =>{ releaseActiveToggle(1); filterByDays(90)}}><p className="text--small text-center">90 days</p></div>
                                            <div className={`col-md-4 box box-xs box--lavender-border ${releaseDaysActive[2].isActive ? 'active' : ''}`} onClick={() =>{ releaseActiveToggle(2); filterByDays(365)}}><p className="text--small text-center">365 days</p></div> */}

                                        </Fragment>
                                    
                                        
                                    ) :
                                    (
                                        <Fragment>
                                            <div className={`col-4 box box-xs box--lavender-border ${releaseDaysActive[0].isActive ? 'active' : ''}`} onClick={() =>{ releaseActiveToggle(0); setPandoraDay(7)}}><p className="text--small text-center">7 days</p></div>
                                            <div className={`col-4 box box-xs box--lavender-border ${releaseDaysActive[1].isActive ? 'active' : ''}`} onClick={() =>{ releaseActiveToggle(1); setPandoraDay(28)}}><p className="text--small text-center">28 days</p></div>
                                            <div className={`col-4 box box-xs box--lavender-border ${releaseDaysActive[2].isActive ? 'active' : ''}`} onClick={() =>{ releaseActiveToggle(2); setPandoraDay(365)}}><p className="text--small text-center">365 days</p></div>

                                        </Fragment>
                                        
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    </Fragment>

                </div>
                
                {/* <div className="row mx-0 my-4 px-4">
                    <div className="col-md-4 pl-0"><p className="text--xs-bold">Metric</p></div>
                    <div className="col-md-2"><p className="text--xs-bold">This week</p></div>
                    <div className="col-md-2"><p className="text--xs-bold">Last week</p></div>
                    <div className="col-md-2"><p className="text--xs-bold text-left">%Change</p></div>
                    <div className="col-md-1"><p className="text--xs-bold text-right">Total</p></div>
                    <div className="col-md-1"><p className="text--xs-bold text-right">Percentile</p></div>

                </div> */}
                {/* playspread */}

                {
                    station && station !== 'pandora' ? (

                        <Fragment>
                            {
                                    isLoadingRelease ? 
                                    (
                                        <div className="d-flex flex-row align-items-center justify-content-center">
                                            <ReleaseIcon   />
                                            <h1 className="text--small-bold text--secondary  my-4 ml-3"> Release data loading</h1>
                                        </div>
                                    )
                                    : release && release.length < 1 ?
                                    (<h1 className="text--small-bold text--secondary text-center my-4">No Data</h1>)
                                    : (
                                        <div className="table-responsive my-4">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                    <th colSpan="3" className="text--xs-bolder text-uppercase">Metric</th>
                                                    <th colSpan="2" className="text--xs-bolder text-uppercase">Artist</th>
                                                    <th colSpan="3" className="text--xs-bolder text-uppercase">Song</th>
                                                    <th colSpan="3" className="text--xs-bolder text-uppercase">Detected Time</th>
                                                    <th colSpan="1"className="text--xs-bolder text-uppercase">Amount</th>
                                                    
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    release && release.map((value, index) => (
                                                        <PlayspreadListItem key={index} {...value} image={getImage(subStationId)} />
                                                    ))
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                        
                        
                        {/* 
                                <div className="row mx-0 my-4 px-4">
                                    <div className="col-3 pl-0 pr-2"><p className="text--xs-bolder text-uppercase">Metric</p></div>
                                    <div className="col-2 px-2"><p className="text--xs-bolder text-uppercase text-center">Artist</p></div>
                                    <div className="col-3 px-2"><p className="text--xs-bolder text-uppercase">Song</p></div>
                                    <div className="col-3 px-2"><p className="text--xs-bolder text-uppercase text-center">Detected Time</p></div>
                                    <div className="col-1 px-2"><p className="text--xs-bolder text-uppercase text-center">Amount</p></div>
                                </div>
                                {
                                    isLoadingRelease ? 
                                    (<h1 className="text--small-bold text--black text-center my-4">Loading ....</h1>)
                                    : release && release.length < 1 ?
                                    (<h1 className="text--small-bold text--black text-center my-4">No Data</h1>)
                                    : release && release.map((value, index) => (
                                        <PlayspreadListItem key={index} {...value} />
                                    ))
                                }
                        */}
                        </Fragment>
                    ) : (
                        <Fragment>
                            {
                                isLoadingRelease ? 
                                ( 
                                <div className="d-flex flex-row align-items-center justify-content-center">
                                    <ReleaseIcon   />
                                    <h1 className="text--small-bold text--secondary  my-4 ml-3"> Release data loading</h1>
                                </div>)
                                : release && release.length < 1 ?
                                (<h1 className="text--small-bold text--secondary text-center my-4">No Data</h1>)
                                : (
                                    <div className="table-responsive my-4">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                <th colSpan="3" className="text--xs-bolder text-uppercase">Metric</th>
                                                <th colSpan="2" className="text--xs-bolder text-uppercase">Song</th>
                                                {pandoraDay === 0 || pandoraDay === 7 || pandoraDay === 28 ? (<th colSpan="3" className="text--xs-bolder text-uppercase"><p>This Week <br/><span className="text--xs">({moment(pandoraDates.this_week_date_from, 'YYYY-MM-DD').format('MMM DD') +' - '+ moment(pandoraDates.this_week_date_to, 'YYYY-MM-DD').format('MMM DD')})</span></p></th>) : null }
                                                {pandoraDay === 0 || pandoraDay === 7 || pandoraDay === 28 ? (<th colSpan="3" className="text--xs-bolder text-uppercase"><p>Last Week <br/><span className="text--xs">({moment(pandoraDates.last_week_date_from, 'YYYY-MM-DD').format('MMM DD') +' - '+ moment(pandoraDates.last_week_date_to, 'YYYY-MM-DD').format('MMM DD')})</span></p></th>) : null }
                                                { pandoraDay === 0 || pandoraDay === 28  ? (<th colSpan="3"className="text--xs-bolder text-uppercase"><p>Last 2 Week <br/><span className="text--xs">({moment(pandoraDates.last_2weeks_date_from, 'YYYY-MM-DD').format('MMM DD') +' - '+ moment(pandoraDates.last_2weeks_date_to, 'YYYY-MM-DD').format('MMM DD')})</span></p></th>) : null }
                                                { pandoraDay === 0 || pandoraDay === 28 || pandoraDay === 365 ? (<th colSpan="3"className="text--xs-bolder text-uppercase"><p>Last 3 Week <br/><span className="text--xs">({moment(pandoraDates.last_3weeks_date_from, 'YYYY-MM-DD').format('MMM DD') +' - '+ moment(pandoraDates.last_3weeks_date_to, 'YYYY-MM-DD').format('MMM DD')})</span></p></th>) : null }
                                                { pandoraDay === 365 ? (<th colSpan="3"className="text--xs-bolder text-uppercase"><p>Last Month</p></th>) : null }
                                                { pandoraDay === 365 ? (<th colSpan="3"className="text--xs-bolder text-uppercase"><p>Year Till Date</p></th>) : null }

                                                <th colSpan="2"className="text--xs-bolder text-uppercase">Amount</th>
                                                
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                release && release.map((value, index) => (
                                                        <PandoraListItem key={index} {...value} day={pandoraDay} />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            }
                            
                            
                            {/* <div className="table-row my-4 px-4">
                                <div className="first-item pr-2"><p className="text--xs-bolder text-uppercase">Metric</p></div>
                                <div className="second-item px-2"><p className="text--xs-bolder text-uppercase">Song</p></div>
                                <div className="other-item px-2"><p className="text--xs-bolder text-uppercase text-center">This Week</p></div>
                                <div className="other-item px-2"><p className="text--xs-bolder text-uppercase text-center">Last Week</p></div>
                                <div className="other-item px-2"><p className="text--xs-bolder text-uppercase text-center">Last 2 Weeks</p></div>
                                <div className="other-item pl-2"><p className="text--xs-bolder text-uppercase text-center">Last 3 Weeks</p></div>
                                <div className="other-item px-2"><p className="text--xs-bolder text-uppercase text-center">Amount</p></div>
                            </div>
                            {
                               isLoadingRelease ? 
                               (<h1 className="text--small-bold text--black text-center my-4">Loading ....</h1>)
                               : release && release.length < 1 ?
                               (<h1 className="text--small-bold text--black text-center my-4">No Data</h1>)
                               :  release && release.map((value, index) => (
                                    <PandoraListItem key={index} {...value} />
                                ))
                            } */}
                        </Fragment>
                    )
                }

                
                { // checks if release is not null and has content
                    release && release.length > 0 ? 
                    (
                        <div className="row my-4">
                            <div className="col-12 col-md-6 ml-auto">
                                <div className="row">
                                    <div className="col-3 col-md-4" style={{cursor: 'pointer'}} onClick={ 
                                        releasePageNumber > 1 ? 
                                        () => {
                                            // setReleasePageNumber(releasePageNumber - 1)
                                            fetchReleaseByPage('subtract');
                                        } : null} >
                                        <div className="pagination pagination--previous text--xs text-center">Previous</div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="pagination--page">
                                            <p className="text--xs-bold">Page {releasePageNumber} of {releasePageTotal} </p>
                                        </div>
                                    </div>
                                    <div className="col-3 col-md-4" style={{cursor: 'pointer'}} onClick={ 
                                        (releasePageNumber >= 1 && releasePageNumber < releasePageTotal) ? 
                                        () => {
                                            // setReleasePageNumber(releasePageNumber + 1)
                                            fetchReleaseByPage('add');
                                        } : null}>
                                        <div className="pagination pagination--next text--xs text-center">Next</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) :  null
                }
            </div>

            {/* reach starts */}
            {/* <div className="content" id="reach">
                <div className="row mx-0 d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row align-items-center">
                        <ReachIcon   />
                        <h3 className="text--medium text--black ml-3">Reach for {artist}</h3>
                    </div>
                </div>
                <div className="row my-4">
                    <div className="col-md-5 px-0">
                        <div className="col mx-0">
                            <div className="row mx-0">
                            <div className="col-md-4 box box-xs box--lavender-border"><p className="text--small text-center">7 days</p></div>
                            <div className="col-md-4 box box-xs box--lavender-border active"><p className="text--small text-center">7 days</p></div>
                            <div className="col-md-4 box box-xs box--lavender-border"><p className="text--small text-center">365 days</p></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mx-0 my-4 px-4">
                    <div className="col-md-4 pl-0"><p className="text--xs-bold">Metric</p></div>
                    <div className="col-md-2"><p className="text--xs-bold">This week</p></div>
                    <div className="col-md-2"><p className="text--xs-bold">Last week</p></div>
                    <div className="col-md-2"><p className="text--xs-bold text-left">%Change</p></div>
                    <div className="col-md-1"><p className="text--xs-bold text-right">Total</p></div>
                    <div className="col-md-1"><p className="text--xs-bold text-right">Percentile</p></div>

                </div>
                <ListItem />
                <ListItem />
                <ListItem />
                <ListItem />
            </div> */}
            {/* reach ends */}

            {/* // new table */}

            {/* {
                station && station !== 'pandora' ? (
                    <div className="content" id="reach">
                        <div className="row mx-0 d-flex flex-row justify-content-between">
                            <div className="d-flex flex-row align-items-center">
                                <ReachIcon   />
                                <h3 className="text--medium text--black ml-3">Reach for {artist}</h3>
                            </div>
                        </div>
                        <div className="row my-4">
                            <div className="col-md-5 px-0">
                                <div className="col mx-0">
                                    <div className="row mx-0">
                                    <div className="col-md-4 box box-xs box--lavender-border"><p className="text--small text-center">30 days</p></div>
                                    <div className="col-md-4 box box-xs box--lavender-border active"><p className="text--small text-center">90 days</p></div>
                                    <div className="col-md-4 box box-xs box--lavender-border"><p className="text--small text-center">365 days</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 my-4 px-4">
                            <div className="col-md-4 pl-0"><p className="text--xs-bolder text-uppercase text-left">Source</p></div>
                            <div className="col-md-2"><p className="text--xs-bolder text-uppercase text-center">Play count</p></div>
                            <div className="col-md-2"><p className="text--xs-bolder text-uppercase text-center">Date From</p></div>
                            <div className="col-md-2"><p className="text--xs-bolder text-uppercase text-center">Date to</p></div>
                            <div className="col-md-2"><p className="text--xs-bolder text-uppercase text-center">Amount</p></div>
                        </div>
                        {
                            isLoadingInfoByLocation ?
                            (<h1 className="text--small-bold text--black text-center my-4">Loading ....</h1>)
                            : artistInfoByLocation && artistInfoByLocation.length < 1 ?
                            (<h1 className="text--small-bold text--black text-center my-4">No Data</h1>)
                            : artistInfoByLocation && artistInfoByLocation.map( (value, index) => (
                                <ArtisteInfoByLocation key={index} {...value}/>
                            ))
                        }

                        { // check its not null or empty
                            artistInfoByLocation && artistInfoByLocation.length > 0 ? 
                            (
                                <div className="row my-4">
                                    <div className="col-md-6 ml-auto">
                                        <div className="row">
                                            <div className="col-md-4" style={{cursor: 'pointer'}} onClick={ 
                                                artistInfoPageNumber > 1 ? 
                                                () => {
                                                    setArtistInfoPageNumber(artistInfoPageNumber - 1)
                                                    fetchArtistInfoByPage();
                                                } : null} >
                                                <div className="pagination pagination--previous text--xs text-center">Previous</div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="d-flex flex-column justify-content-center h-100">
                                                    <p className="text--xs-bold">Page {artistInfoPageNumber} of {artistInfoPageTotal} </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4" style={{cursor: 'pointer'}} onClick={ 
                                                (artistInfoPageNumber >= 1 && artistInfoPageNumber < artistInfoPageTotal) ? 
                                                () => {
                                                    setArtistInfoPageNumber(artistInfoPageNumber + 1)
                                                    fetchArtistInfoByPage();
                                                } : null}>
                                                <div className="pagination pagination--next text--xs text-center">Next</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        }
                        
                    </div>
                ) : null
            } */}
            
        </div>
    </div>
)
    }

export default SearchResult